module.exports = __webpack_public_path__ + "static/media/flag-dv.22a0afee.webp";